export default {
	Eletricista: "Eletricista",
	OperadordeTrabalhoemAltura: "Operador de Trabalho em Altura",
	Arquiteto: "Arquiteto (a)",
	EngenheiroCivil: "Engenheiro (a) Civil",
	DesignerDeInteriores: "Designer De Interiores",
	Visitante: "Visitante",
	Other: "Outro"
};
